import { NextResponse } from 'next/server'
import { query, queryOne, uuid } from '@/lib/db'

const VALID_TYPES = ['avance', 'paiement', 'vente'] as const
type TxType = typeof VALID_TYPES[number]

export async function GET(_: Request, { params }: { params: Promise<{ id: string }> }) {
  const { id } = await params
  const client = await queryOne('SELECT * FROM clients WHERE id = ?', [id])
  if (!client) return NextResponse.json({ error: 'Not found' }, { status: 404 })

  const transactions = await query(
    'SELECT * FROM client_transactions WHERE client_id = ? ORDER BY created_at DESC LIMIT 100',
    [id]
  )
  return NextResponse.json({ ...client, transactions })
}

export async function PUT(req: Request, { params }: { params: Promise<{ id: string }> }) {
  const { id } = await params
  const { name, phone } = await req.json()
  await query('UPDATE clients SET name = ?, phone = ? WHERE id = ?', [name, phone || null, id])
  return NextResponse.json({ ok: true })
}

export async function DELETE(_: Request, { params }: { params: Promise<{ id: string }> }) {
  const { id } = await params
  await query('DELETE FROM client_transactions WHERE client_id = ?', [id])
  await query('DELETE FROM clients WHERE id = ?', [id])
  return NextResponse.json({ ok: true })
}

// Enregistre une transaction client et met à jour le solde.
//   type='vente'    → achat à crédit : solde -= montant  (montant = dette NETTE ajoutée)
//   type='paiement' → remboursement  : solde += montant
//   type='avance'   → pré-paiement   : solde += montant
export async function POST(req: Request, { params }: { params: Promise<{ id: string }> }) {
  const { id } = await params
  const body = await req.json()

  const type = body.type as TxType
  const montant = Math.abs(parseFloat(body.montant))
  const note = body.note || null
  const venteId = body.vente_id || null

  // Validation stricte — évite les enum invalides
  if (!VALID_TYPES.includes(type)) {
    return NextResponse.json({ error: `Type invalide: ${type}` }, { status: 400 })
  }
  if (!Number.isFinite(montant) || montant <= 0) {
    return NextResponse.json({ error: 'Montant invalide' }, { status: 400 })
  }

  const client = await queryOne<any>('SELECT id, shop_id, solde FROM clients WHERE id = ?', [id])
  if (!client) return NextResponse.json({ error: 'Client introuvable' }, { status: 404 })

  const delta = type === 'vente' ? -montant : +montant

  await query('UPDATE clients SET solde = solde + ? WHERE id = ?', [delta, id])
  await query(
    'INSERT INTO client_transactions (id, shop_id, client_id, type, montant, note, vente_id) VALUES (?, ?, ?, ?, ?, ?, ?)',
    [uuid(), client.shop_id, id, type, montant, note, venteId]
  )

  const updated = await queryOne<any>('SELECT solde FROM clients WHERE id = ?', [id])
  return NextResponse.json({ ok: true, solde: parseFloat(updated?.solde ?? '0') })
}
